export const SuggestionsQuestions2 =[
    {
        id:"R2-01",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章1，「道統」一詞由哪一位文人提出？',
        options:[
            {
                option:'A. 杜甫',
            },
            {
                option:'B. 范仲淹',
            },
            {
                option:'C. 于謙',
            },
            {
                option:'D. 韓愈',
            }
        ],
        correctAnswer:'D. 韓愈',
        explanation: '篇章1第二段直接交代韓愈提出此詞。',
        score: 1,
        source: '篇章1 第2段',
        articleIndex: [0]
    },
    {
        id: "R2-02",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章1所說的「惻隱之心」是甚麼？',
        options:[
            {
                option:'A. 只在乎自己的成敗',
            },
            {
                option:'B. 看見別人受苦時感到不忍',
            },
            {
                option:'C. 希望別人承認自己的地位',
            },
            {
                option:'D. 害怕受到批評而保持沉默',
            }
        ],
        correctAnswer:'B. 看見別人受苦時感到不忍',
        explanation: '篇章1直接解釋為看到他人受苦會感到不忍心的本能。',
        score: 1,
        source: '篇章1 第3段',
        articleIndex: [0]
    },
    {
        id: "R2-03",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章2，「弘毅」最恰當的解釋是甚麼？',
        options:[
            {
                option:'A. 寬廣的胸懷和堅忍的意志',
            },
            {
                option:'B. 豐富的財富和顯赫的地位',
            },
            {
                option:'C. 流利的口才和出眾的外貌',
            },
            {
                option:'D. 高深的學識和悠閒的生活',
            }
        ],
        correctAnswer:'A. 寬廣的胸懷和堅忍的意志',
        explanation: '篇章2語譯直接說明弘毅的意思。',
        score: 1,
        source: '篇章2 原文及語譯',
        articleIndex: [1]
    },
    {
        id: "R2-04",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章3兩次寫君王奏樂，百姓卻有相反反應。最主要的原因是甚麼？',
        options:[
            {
                option:'A. 兩次樂器的音色完全不同',
            },
            {
                option:'B. 百姓只喜歡某一種音樂',
            },
            {
                option:'C. 君王是否能與百姓同樂',
            },
            {
                option:'D. 君王演奏音樂的時間不同',
            }
        ],
        correctAnswer:'C. 君王是否能與百姓同樂',
        explanation: '文本明確把反應差異歸結為與民同樂與否。',
        score: 1,
        source: '篇章3 原文前兩段',
        articleIndex: [2]
    },
    {
        id: "R2-05",
        category:"一般閱讀題",
        type:'選擇題',
        question: '綜合三篇材料，士大夫超越個人得失的精神基礎最接近哪一項？',
        options:[
            {
                option:'A. 只有取得權位，人生才有價值',
            },
            {
                option:'B. 只要保存生命，便應放棄道義',
            },
            {
                option:'C. 只須提高才華，不必關懷他人',
            },
            {
                option:'D. 把道德理想與天下人民的福祉視為長久責任',
            }
        ],
        correctAnswer:'D. 把道德理想與天下人民的福祉視為長久責任',
        explanation: '篇章1談道統，篇章2談任仁，篇章3談與天下同憂樂。',
        score: 1,
        source: '篇章1至3',
        articleIndex: [0,1,2]
    },
    {
        id: "R2-06",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章1，「天下為公」的理想社會如何照顧不同群體？請寫出兩項。',
        options:[],
        correctAnswer:'例如：老人能安享晚年；幼童能健康成長；鰥寡孤獨者皆獲照養。',
        explanation: '任意兩項各1分。',
        score: 2,
        source: '篇章1 第3段',
        articleIndex: [0]
    },
    {
        id: "R2-07",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章1，簡述「治統」與「道統」的分別。',
        options:[],
        correctAnswer:'治統指皇帝掌握的政治延續；道統指士大夫傳承的道德與文化。',
        explanation: '治統解釋（1分）；道統解釋（1分）。',
        score: 2,
        source: '篇章1 第4段',
        articleIndex: [0]
    },
    {
        id: "R2-08",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章2，為甚麼「士」需要具有「弘毅」？請把責任及時間兩方面連繫起來說明。',
        options:[],
        correctAnswer:'士以實現仁為己任，責任重大；這項追求須終身堅持、道路漫長，所以需要寬廣胸懷與堅忍意志。',
        explanation: '任務重大（1分）；終身持續（1分）；連繫到弘毅的需要（1分）。',
        score: 3,
        source: '篇章2 全文',
        articleIndex: [1]
    },
    {
        id: "R2-09",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章3中百姓聽到鐘鼓聲後關心君王是否健康，反映君民之間有甚麼關係？請說明推論依據。',
        options:[],
        correctAnswer:'反映君民情感相通、百姓願意關心君王。因君王與民同樂，百姓便以君王的快樂為樂，並關心他的健康。',
        explanation: '合理關係推斷（1分）；引用百姓言行（1分）；連繫與民同樂的原因（1分）。',
        score: 3,
        source: '篇章3 第2至3段',
        articleIndex: [2]
    },
    {
        id: "R2-10",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章1中的杜甫與篇章3所提倡的君王，在面對他人憂樂時有甚麼共同點？請各舉一項內容。',
        options:[],
        correctAnswer:'杜甫自己受凍仍希望天下寒士有廣廈安居；孟子提倡君王以百姓的憂樂為自己的憂樂。兩者都把關懷由個人擴展到眾人。',
        explanation: '杜甫的內容（1分）；孟子的內容（1分）；共同點（1分）。',
        score: 3,
        source: '篇章1 杜甫例子；篇章3末段',
        articleIndex: [0,2]
    },
    {
        id: "R2-11",
        category:"能力點題",
        type:'選擇題',
        question: '篇章1引用「粉骨碎身渾不怕，要留清白在人間」來說明哪一位人物？',
        options:[{
            option:'A. 韓愈'
        },{
            option:'B. 于謙'
        },{
            option:'C. 孔子'
        },{
            option:'D. 曾子'
        }],
        correctAnswer:'B. 于謙',
        explanation: '篇章1把此句列為明代于謙〈石灰吟〉的內容。',
        score: 1,
        source: '篇章1 范仲淹及于謙部分',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: "R2-12",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章3「原文」括號內的提示，孟子向誰說話？',
        options:[{
            option:'A. 梁惠王'
        },{
            option:'B. 宋仁宗'
        },{
            option:'C. 范仲淹'
        },{
            option:'D. 齊宣王'
        }],
        correctAnswer:'D. 齊宣王',
        explanation: '原文標明「孟子對齊宣王曰」。題目指定原文提示，避免與篇名混淆。',
        score: 1,
        source: '篇章3 原文開首括注',
        articleIndex: [2],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: "R2-13",
        category:"能力點題",
        type:'短答題',
        question: '從篇章2原文摘錄最直接說明「士」以甚麼為己任的一句話。',
        options:[],
        correctAnswer:'「仁以為己任」。',
        explanation: '準確摘錄該句得1分。',
        score: 1,
        source: '篇章2 原文',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: "R2-14",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章3，在不與民同樂的情況下，百姓提到哪兩種家庭困境？',
        options:[],
        correctAnswer:'父子不能相見；兄弟妻子離散。',
        explanation: '每項1分；接受意思相同的白話表述。',
        score: 2,
        source: '篇章3 原文第1段及語譯',
        articleIndex: [2],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: "R2-15",
        category:"能力點題",
        type:'選擇題',
        question: '你要查找「士的責任為甚麼需要終身堅持」的原文依據，最應先讀哪一項？',
        options:[{
            option:'A. 篇章1于謙的詩句'
        },{
            option:'B. 篇章3奏樂的兩種反應'
        },{
            option:'C. 篇章2「死而後已」及其語譯'
        },{
            option:'D. 篇章1「斯人」的超連結定義'
        }],
        correctAnswer:'C. 篇章2「死而後已」及其語譯',
        explanation: '篇章2直接交代士之責任的時間跨度。',
        score: 1,
        source: '篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: "R2-16",
        category:"能力點題",
        type:'選擇題',
        question: '要研究「君王的憂樂如何影響百姓對他的態度」，哪一組資料最直接相關？',
        options:[{
            option:'A. 篇章3的奏樂對照與末段君民憂樂關係'
        },{
            option:'B. 篇章1的詞語起源與作者朝代'
        },{
            option:'C. 篇章2的篇名與字數標示'
        },{
            option:'D. 篇章1「士」原指最低階級貴族的介紹'
        }],
        correctAnswer:'A. 篇章3的奏樂對照與末段君民憂樂關係',
        explanation: '篇章3同時提供情境及概括性的解說。',
        score: 1,
        source: '篇章3',
        articleIndex: [2],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: "R2-17",
        category:"能力點題",
        type:'短答題',
        question: '你要為「由個人修養到公共責任」製作閱讀資料卡，請從三篇材料中選出兩個不同篇章，各指出一項最相關的內容及用途。',
        options:[],
        correctAnswer:'可選篇章1孔子對士的定義，說明修德救世；選篇章2「仁以為己任」，說明長久承擔責任。亦可選篇章3與天下同憂樂，說明公共關懷。',
        explanation: '兩個不同篇章的合適內容各1分；各自用途各1分。',
        score: 4,
        source: '篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: "R2-18",
        category:"能力點題",
        type:'短答題',
        question: '你要核對「弘毅」的意思，再找一個把關懷推向天下的古人例子。請寫出閱讀次序、選讀位置及選擇理由。',
        options:[],
        correctAnswer:'先讀篇章2語譯，直接確認弘毅為胸懷寬廣、意志堅忍；再讀篇章1杜甫或范仲淹的例子，觀察人物如何超越自身處境關懷天下。',
        explanation: '第一個位置及理由（1分）；第二個位置及理由（1分）；閱讀次序符合查詞再找例的目的（1分）。',
        score: 3,
        source: '篇章2語譯；篇章1人物例子',
        articleIndex: [1,0],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: "R2-19",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章2，「死而後已」在此處的意思是甚麼？',
        options:[{
            option:'A. 把實踐仁的責任堅持到生命終結'
        },{
            option:'B. 必須尋求死亡才能盡責'
        },{
            option:'C. 只要工作辛苦便可停止'
        },{
            option:'D. 等待他人完成理想才開始行動'
        }],
        correctAnswer:'A. 把實踐仁的責任堅持到生命終結',
        explanation: '這句強調承擔責任的終身性，並非要求尋死。',
        score: 1,
        source: '篇章2 原文及語譯',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: "R2-20",
        category:"能力點題",
        type:'選擇題',
        question: '篇章3「樂民之樂者，民亦樂其樂」的意思最接近哪一項？',
        options:[{
            option:'A. 君王只要奏樂，百姓便必定幸福'
        },{
            option:'B. 百姓的快樂與君王毫無關係'
        },{
            option:'C. 君王必須先獲百姓送禮才可快樂'
        },{
            option:'D. 君王以百姓的快樂為樂，百姓也會為君王的快樂而高興'
        }],
        correctAnswer:'D. 君王以百姓的快樂為樂，百姓也會為君王的快樂而高興',
        explanation: '表達君民之間相互回應的憂樂關係。',
        score: 1,
        source: '篇章3 末段及語譯',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: "R2-21",
        category:"能力點題",
        type:'短答題',
        question: '用自己的話解釋篇章2「任重而道遠」中的「重」和「遠」分別指甚麼。',
        options:[],
        correctAnswer:'「重」指實現仁的責任重大；「遠」指須終身承擔，追求理想的道路漫長。',
        explanation: '責任重大（1分）；終身持續或道路漫長（1分）。',
        score: 2,
        source: '篇章2 原文及語譯',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: "R2-22",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章3語譯，解釋「樂以天下，憂以天下」。',
        options:[],
        correctAnswer:'與天下百姓同樂，也與天下百姓同憂，把百姓的憂樂放在心上。',
        explanation: '同樂的意思（1分）；同憂的意思（1分）。',
        score: 2,
        source: '篇章3 末段及語譯',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: "R2-23",
        category:"能力點題",
        type:'選擇題',
        question: '篇章1中杜甫自己的茅屋被吹破，卻想到天下寒士。可推斷他的關懷有甚麼特點？',
        options:[{
            option:'A. 只重視詩歌是否傳世'
        },{
            option:'B. 從自身痛苦推及處境相近的人'
        },{
            option:'C. 希望用施恩取得官職'
        },{
            option:'D. 認為自己的困境完全不重要'
        }],
        correctAnswer:'B. 從自身痛苦推及處境相近的人',
        explanation: '他由個人苦難想到他人的生活需要，表現推己及人。',
        score: 1,
        source: '篇章1 杜甫例子',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id: "R2-24",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2說理想尚未實現，即使面對困難也不能輕易放棄。這暗示士的責任具有哪一種性質？',
        options:[{
            option:'A. 只在短期獲利時才有效'
        },{
            option:'B. 須等待環境完全理想才承擔'
        },{
            option:'C. 不隨一時成敗而輕易終止'
        },{
            option:'D. 只限於在朝廷任職期間'
        }],
        correctAnswer:'C. 不隨一時成敗而輕易終止',
        explanation: '導讀強調長久承擔，而非依短期得失決定。',
        score: 1,
        source: '篇章2 導讀',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id: "R2-25",
        category:"能力點題",
        type:'短答題',
        question: '篇章1說真正的儒家士大夫認為「道統比皇權更重要」。如果君主要求他們做違背道義的事，可推斷他們會採取甚麼立場？請用文中內容支持。',
        options:[],
        correctAnswer:'會以道義為判斷標準，不因皇命便盲從。文中說他們做官是捍衛道，也會在政治不公甚至有生命危險時堅守信念。',
        explanation: '合理推斷立場（1分）；相關文本證據（1分）；解釋證據與推斷的關係（1分）。',
        score: 3,
        source: '篇章1 第4段及其後',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id: "R2-26",
        category:"能力點題",
        type:'短答題',
        question: '篇章3中百姓對同一種鐘鼓聲可以頭痛皺眉，也可以面露喜色。從中可推斷他們評價君王時更重視甚麼？',
        options:[],
        correctAnswer:'更重視自身生活是否安穩、君王是否關心百姓，而不是鐘鼓本身是否悅耳。文中將兩種反應分別歸因於不與民同樂和與民同樂。',
        explanation: '合理推斷（1分）；以兩種反應的原因支持（1分）。',
        score: 2,
        source: '篇章3 前兩段',
        articleIndex: [2],
        ability_point: '2.2 生成推斷'
    },
    {
        id: "R2-27",
        category:"能力點題",
        type:'選擇題',
        question: '根據〈中國士大夫的「道統」〉一文，作者在末段提及范仲淹，主要是為了說明他如何實踐哪一種士大夫精神？',
        options:[{
            option:'A. 追求個人的清靜自守'
        },{
            option:'B. 以天下和百姓為念，承擔公共責任'
        },{
            option:'C. 以文學成就作為人生最高目標'
        },{
            option:'D. 遠離仕途以保存個人品格'
        }],
        correctAnswer:'B. 以天下和百姓為念，承擔公共責任',
        explanation: '以「先天下之憂而憂，後天下之樂而樂」說明道統中的公共責任。原題「末段」沿用原文表述；藍圖中例子實位於倒數第二段。',
        score: 1,
        source: '單元習題 閱讀2／2.3 選擇題1；篇章1 范仲淹例子',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id: "R2-28",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章3的兩個奏樂情境及末段議論，哪項最完整地概括文章主張？',
        options: [
            {
                option:'A. 百姓只要聽見音樂便會反對君王',
            },
            {
                option:'B. 君王必須完全取消個人的娛樂',
            },
            {
                option:'C. 國家安定只取決於樂器的種類',
            },
            {
                option:'D. 君王應關懷百姓的生活，與民同憂樂以獲民心',
            }
        ],
        correctAnswer:'D. 君王應關懷百姓的生活，與民同憂樂以獲民心',
        explanation: '把百姓生活、情感反應與君王施政責任連成完整主張。',
        score: 1,
        source: '篇章3 全文',
        articleIndex: [2],
        ability_point: '2.3 整合文本內信息',
    },
    {
        id: "R2-29",
        category:"能力點題",
        type:'短答題',
        question: '根據〈中國士大夫的「道統」〉一文，士大夫希望建立一個理想的「天下為公」的社會，作者並在文章末段提及范仲淹。你認為范仲淹如何體現建立天下為公社會的「道統」？試舉例說明。',
        options: [],
        correctAnswer:'范仲淹以「先天下之憂而憂，後天下之樂而樂」表明把天下人的憂患置於個人享樂之前，承擔公共責任，呼應道統為百姓追求更好生活的理想。',
        explanation: '準確例子（1分）；說明憂樂先後的責任意義（1分）；連繫天下為公／道統（1分）。原題「末段」沿用；例子見篇章1倒數第二段。',
        score: 3,
        source: '單元習題 閱讀2／2.3 原短答題；篇章1',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id: "R2-30",
        category:"能力點題",
        type:'短答題',
        question: '綜合篇章1對孔子、孟子及後世士大夫的論述，概括「道統」如何把個人修養連繫到理想社會。',
        options: [],
        correctAnswer:'孔子所說的士讀書修德並以救世為目標；孟子主張由惻隱之心推行仁政；後世士大夫堅守道德、關懷百姓，以追求天下為公。',
        explanation: '個人修德（1分）；仁心轉化為仁政（1分）；連繫後世實踐與理想社會（1分）。',
        score: 3,
        source: '篇章1 全文',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息',
    },
    {
        id: "R2-31",
        category:"能力點題",
        type:'選擇題',
        question: '綜合互文閱讀2「文化傳統」篇章1至3，孔子、曾子和孟子對「道統」的觀點最主要的共同點是甚麼？',
        options: [
            {
                option:'A. 重視個人名聲多於社會責任',
            },
            {
                option:'B. 強調士人應修養德行並承擔對天下的責任',
            },
            {
                option:'C. 主張只有出仕才能實現人生價值',
            },
            {
                option:'D. 認為理想人格與社會生活沒有關係',
            }
        ],
        correctAnswer:'B. 強調士人應修養德行並承擔對天下的責任',
        explanation: '三篇分別以修德救世、以仁為任、與天下同憂樂連繫德行與公共責任。',
        score: 1,
        source: '單元習題 閱讀2／2.4 選擇題1；篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id: "R2-32",
        category:"能力點題",
        type:'選擇題',
        question: '把篇章2「仁以為己任」與篇章3「憂以天下」合讀，哪一項最能說明兩者的關係？',
        options: [
            {
                option:'A. 前者只求個人名望，後者完全否定修養',
            },
            {
                option:'B. 前者要求退出社會，後者要求放棄理想',
            },
            {
                option:'C. 前者提出長久的道德責任，後者展示關懷天下憂樂的方向',
            },
            {
                option:'D. 兩者只是在說如何改善音樂表演',
            }
        ],
        correctAnswer:'C. 前者提出長久的道德責任，後者展示關懷天下憂樂的方向',
        explanation: '合讀可由責任的承擔，理解其面向天下的內容。',
        score: 1,
        source: '篇章2 原文；篇章3末段',
        articleIndex: [1,2],
        ability_point: '2.4 整合跨文本信息',
    },
    {
        id: "R2-33",
        category:"能力點題",
        type:'短答題',
        question: '根據互文閱讀2：「文化傳統」」篇章1-3，孔子、曾子和孟子對「道統」的觀點有何相近之處？試略加說明。',
        correctAnswer: '三者都把德行與天下責任相連：篇章1孔子重視讀書修德以救世；篇章2曾子主張以仁為己任、終身不懈；篇章3孟子主張與天下百姓同憂樂。',
        explanation: '共同點（1分）；孔子、曾子、孟子的相應內容各1分。原題的重複引號按原文保留。',
        score: 4,
        source: '單元習題 閱讀2／2.4 原短答題；篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id: "R2-34",
        category:"能力點題",
        type:'短答題',
        question: '篇章1的范仲淹與篇章3的孟子都談到「憂」「樂」。請指出共同關懷，再說明兩段表述各自着重甚麼。',
        correctAnswer: '共同關懷是天下百姓的福祉。范仲淹強調先憂後樂，把責任置於個人享受之前；孟子強調君王與百姓同憂同樂及君民情感的相互回應。',
        explanation: '共同關懷（1分）；范仲淹重點（1分）；孟子重點（1分）。',
        score: 3,
        source: '篇章1 范仲淹例子；篇章3末段',
        articleIndex: [0,2],
        ability_point: '2.4 整合跨文本信息',
    },
    {
        id: "R2-35",
        category:"能力點題",
        type:'選擇題',
        question: '有人只憑篇章1說「很多文人堅守信念」，便斷言「古代每一位官員都不曾違背道義」。應如何評估？',
        options: [
            {
                option:'A. 證據不足，文中的部分例子不能證明所有官員都如此',
            },
            {
                option:'B. 正確，因為文章列出三位古人',
            },
            {
                option:'C. 正確，因為道統是古代思想',
            },
            {
                option:'D. 錯誤，因為任何人物例子都不能作證據',
            }
        ],
        correctAnswer:'A. 證據不足，文中的部分例子不能證明所有官員都如此',
        explanation: '須區分「很多」與「每一位」，不能無限擴大例證範圍。',
        score: 1,
        source: '篇章1 開首及人物例子',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id: "R2-36",
        category:"能力點題",
        type:'選擇題',
        question: '若要確認篇章3三段引文在《孟子》中的原來位置，哪一項最可靠？',
        options: [
            {
                option:'A. 只看插圖人物的服飾',
            },
            {
                option:'B. 依據檔案列出的字數',
            },
            {
                option:'C. 只看導讀是否容易理解',
            },
            {
                option:'D. 逐段查對有章次與版本資料的《孟子》文本',
            }
        ],
        correctAnswer:'D. 逐段查對有章次與版本資料的《孟子》文本',
        explanation: '合併呈現的節選應逐段核對，導讀及插圖不能代替出處。',
        score: 1,
        source: '篇章3 節選引文',
        articleIndex: [2],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id: "R2-37",
        category:"能力點題",
        type:'短答題',
        question: '篇章1引用于謙的詩句來說明他堅守清白。單靠詩句，是否足以證明他一生每項行動都符合這個理想？請說明，並提出一種補充資料。',
        options: [],
        correctAnswer:'不足。詩句表達理想或志向，不能單獨證實一生所有行動。可補充具出處的生平事跡或史料，考察其實際行為。',
        explanation: '區分志向表達與行為事實（1分）；指出不能推論全部行動（1分）；合適補充資料（1分）。',
        score: 3,
        source: '篇章1 于謙例子',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id: "R2-38",
        category:"能力點題",
        type:'短答題',
        question: '有同學把篇章2「導讀」的整段解說當成曾子的逐字原話。你會如何判斷這份引文的準確性？',
        options: [],
        correctAnswer:'不準確。導讀是對原文的解說；曾子的直接引文列在「原文」下。應核對原文，只把相符的文字標作直接引語，其餘標為解釋或概述。',
        explanation: '辨別導讀與原文（1分）；核對方式（1分）；提出正確標示方法（1分）。',
        score: 3,
        source: '篇章2 導讀、原文及語譯',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id: "R2-39",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2連用「不亦重乎」「不亦遠乎」有甚麼主要作用？',
        options: [
            {
                option:'A. 真正要求讀者提供路程數字',
            },
            {
                option:'B. 把實踐仁描述成輕鬆的活動',
            },
            {
                option:'C. 以反問加強責任重大、承擔長久的語氣',
            },
            {
                option:'D. 表示曾子不確定士是否需要責任',
            }
        ],
        correctAnswer:'C. 以反問加強責任重大、承擔長久的語氣',
        explanation: '反問強化肯定意思，呼應任重道遠。',
        score: 1,
        source: '篇章2 原文',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id: "R2-40",
        category:"能力點題",
        type:'選擇題',
        question: '篇章3重複「今王鼓樂於此」，再寫兩種百姓反應，有甚麼表達作用？',
        options: [
            {
                option:'A. 以相同場景作對照，突出與民同樂的重要',
            },
            {
                option:'B. 強調君王每次奏樂的技術不同',
            },
            {
                option:'C. 避免討論百姓生活是否困苦',
            },
            {
                option:'D. 說明全文只有時間先後而沒有論證',
            }
        ],
        correctAnswer:'A. 以相同場景作對照，突出與民同樂的重要',
        explanation: '相似場景與相反反應突出造成差別的治理態度。',
        score: 1,
        source: '篇章3 前兩段',
        articleIndex: [2],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id: "R2-41",
        category:"能力點題",
        type:'短答題',
        question: '篇章1為甚麼不只解釋「道統」一詞，還舉杜甫、范仲淹、于謙等人的例子？請說明兩項作用。',
        options: [],
        correctAnswer:'人物與作品使抽象的道統具體可理解；不同時代的例子也呈現這種精神的傳承，支持文章主題。',
        explanation: '使抽象概念具體化（1分）；展示跨時代傳承或支持主題（1分），均須略作解釋。',
        score: 2,
        source: '篇章1 人物例子',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id: "R2-42",
        category:"能力點題",
        type:'短答題',
        question: '篇章3以「疾首蹙頞」和「欣欣然有喜色」寫百姓的神態，怎樣加強論述效果？',
        options: [],
        correctAnswer:'強烈對照使百姓痛苦與喜悅變得可感，突顯君王是否與民同樂對百姓態度的影響，比只作抽象說理更鮮明。',
        explanation: '辨識神態對照（1分）；連繫與民同樂的論點（1分）；說明鮮明或具體的效果（1分）。',
        score: 3,
        source: '篇章3 前兩段',
        articleIndex: [2],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id: "R2-43",
        category:"能力點題",
        type:'選擇題',
        question: '篇章1重視道德修養，篇章2又說仁不只是個人修養。這是否必然矛盾？',
        options: [
            {
                option:'A. 是，因為個人修養必定排斥公共責任',
            },
            {
                option:'B. 是，因為兩篇使用不同詞語',
            },
            {
                option:'C. 否，因為兩篇完全沒有討論同一問題',
            },
            {
                option:'D. 否，個人修養可以成為承擔公共責任的基礎',
            }
        ],
        correctAnswer:'D. 否，個人修養可以成為承擔公共責任的基礎',
        explanation: '「不只是」擴展概念的範圍，並不否定修養本身。',
        score: 1,
        source: '篇章1 孔子與士；篇章2導讀',
        articleIndex: [0,1],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id: "R2-44",
        category:"能力點題",
        type:'選擇題',
        question: '篇章3的插圖提示寫「孟子遊說梁惠王」，原文括注卻寫「孟子對齊宣王曰」。製作教材時應如何處理？',
        options: [
            {
                option:'A. 只按篇名判定對話者必是梁惠王',
            },
            {
                option:'B. 標示人物記述有差異，查核原典後統一插圖與引文',
            },
            {
                option:'C. 把兩位君王視為同一人',
            },
            {
                option:'D. 刪去原文，只保留插圖提示',
            }
        ],
        correctAnswer:'B. 標示人物記述有差異，查核原典後統一插圖與引文',
        explanation: '插圖提示與原文括注指向不同人物，須查證，不能用篇名直接代替對話者。',
        score: 1,
        source: '教學藍圖 閱讀2篇章3 插圖提示及原文括注',
        articleIndex: [2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id: "R2-45",
        category:"能力點題",
        type:'短答題',
        question: '有同學認為「道統比皇權重要」與「士大夫做官」互相矛盾。請根據篇章1說明，兩者能否並存。',
        options: [],
        correctAnswer:'可以。士大夫可透過做官實踐道德與護民理想，但不把服從皇帝視為最高原則；若政令不義，仍須以道義作判斷。',
        explanation: '指出可以並存（1分）；說明做官是實踐理想的途徑（1分）；說明道義可高於服從皇權（1分）。',
        score: 3,
        source: '篇章1 第2至4段',
        articleIndex: [0],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id: "R2-46",
        category:"能力點題",
        type:'短答題',
        question: '同學甲說「范仲淹先憂後樂，所以士大夫永遠不應快樂」，同學乙說「孟子與民同樂，所以可以只管享樂」。請用兩篇材料修正這兩種理解。',
        options: [],
        correctAnswer:'先憂後樂是把天下責任置前，並非永遠否定快樂；與民同樂須關懷百姓生活，也同憂，並非只顧個人享樂。兩者都要求以百姓福祉為重。',
        explanation: '用篇章1修正甲的說法（1分）；用篇章3修正乙的說法（1分）；說明共同原則（1分）。',
        score: 3,
        source: '篇章1 范仲淹例子；篇章3',
        articleIndex: [0,2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id: "R2-47",
        category:"能力點題",
        type:'選擇題',
        question: '閱讀以下情境：某人在國家和百姓面臨困難時，仍堅持自己的道德責任，長期承擔艱鉅工作，不因個人得失而放棄。這最符合〈曾子論「士」〉所強調的哪一種精神？',
        options: [{
            option:'A. 追求安逸，避免承擔重任',
        },
        {
            option:'B. 弘毅任重，堅持所承擔的責任',
        },
        {
            option:'C. 隨遇而安，不問公共事務',
        },
        {
            option:'D. 重視個人才華，多於道德責任',
        }
        ],
        correctAnswer:'B. 弘毅任重，堅持所承擔的責任',
        explanation: '情境的長期承擔與不因得失放棄，對應弘毅任重。',
        score: 1,
        source: '單元習題 閱讀2／4.1 選擇題1；篇章2',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境',
        isSuggested: true,
    },
    {
        id: "R2-48",
        category:"能力點題",
        type:'選擇題',
        question: '學校慶祝活動有同學因費用太高而無法參加。參照篇章3，學生會哪一項回應最合適？',
        options: [{
            option:'A. 只提高音響效果，讓場內更熱鬧',
        },
        {
            option:'B. 請無法參加者自行承擔所有困難',
        },
        {
            option:'C. 先了解費用障礙，調整安排讓更多同學共享活動',
        },
        {
            option:'D. 只向已報名者收集讚美的意見',
        }
        ],
        correctAnswer:'C. 先了解費用障礙，調整安排讓更多同學共享活動',
        explanation: '與民同樂可遷移為關注被排除者的需要，改善共同參與的條件。',
        score: 1,
        source: '篇章3；新增校園情境',
        articleIndex: [2],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id: "R2-49",
        category:"能力點題",
        type:'短答題',
        question: '在你認識的中國歷史人物中，有哪些人符合〈曾子論「士」〉的精神？試舉出其中一位和一項文本內容，略加說明。',
        options: [],
        correctAnswer: '例如范仲淹：以「先天下之憂而憂，後天下之樂而樂」表明長久心繫百姓，對應曾子「仁以為己任」或「任重而道遠」。可接受其他人物，但事跡須準確且連繫合理。',
        explanation: '人物及準確事例（1分）；曾子文本內容（1分）；具體說明二者連繫（1分）。',
        score: 3,
        source: '單元習題 閱讀2／4.1 原短答題；篇章2；例子可據篇章1',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境',
        isSuggested: true,
    },
    {
        id: "R2-50",
        category:"能力點題",
        type:'短答題',
        question: '你參與長期義工服務，因一次活動效果欠佳而想退出。根據篇章2，提出下一步的具體做法，並說明它如何體現「弘毅」。',
        options: [],
        correctAnswer: '先聽取服務對象意見、調整安排，與同伴分工繼續服務。胸懷寬廣使人重視他人需要，堅忍意志使人不因一次挫敗放棄，但可改善方法。',
        explanation: '具體可行做法（1分）；連繫寬廣胸懷（1分）；連繫堅忍而能改善方法（1分）。',
        score: 3,
        source: '篇章2；新增義工情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id: "R2-51",
        category:"能力點題",
        type:'選擇題',
        question: '你要設計一張「士的精神在今天」海報，哪組標題與活動最能把曾子和孟子的思想轉化為清楚訊息？',
        options: [{
            option:'A. 同憂同樂，長久同行：持續了解同學需要並提供互助',
        },
        {
            option:'B. 只爭第一，不問他人：以個人排名作唯一目標',
        },
        {
            option:'C. 一日熱心，足夠終身：活動結束便不再跟進',
        },
        {
            option:'D. 安逸最重，責任可免：取消所有公共服務',
        }
        ],
        correctAnswer:'A. 同憂同樂，長久同行：持續了解同學需要並提供互助',
        explanation: '標題與行動兼顧長久承擔和共同憂樂，對應兩篇思想。',
        score: 1,
        source: '篇章2、3；新增海報任務',
        articleIndex: [1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id: "R2-52",
        category:"能力點題",
        type:'選擇題',
        question: '要把「道統」寫成供初中生閱讀的故事，哪一個結局最切合三篇材料的共同精神？',
        options: [{
            option:'A. 主角因一次失敗而把他人的需要全部擱置',
        },
        {
            option:'B. 主角獲得獎項後，便認為不用再服務',
        },
        {
            option:'C. 主角為得到掌聲，隱瞞服務對象的困難',
        },
        {
            option:'D. 主角即使未獲表揚，仍調整方法、長久回應眾人的需要',
        }
        ],
        correctAnswer:'D. 主角即使未獲表揚，仍調整方法、長久回應眾人的需要',
        explanation: '新故事須保留道德、堅持與公共關懷，而不只追逐個人回報。',
        score: 1,
        source: '篇章1至3；新增故事任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id: "R2-53",
        category:"能力點題",
        type:'短答題',
        question: '為校園互助計劃創作一句不多於20字的口號，再用40至60字說明，結合曾子及孟子的思想表達計劃宗旨。',
        options: [],
        correctAnswer: '口號示例：「把關懷做下去，讓憂樂不孤單。」說明：我們以長久服務為責任，遇到困難也持續改善；既關心同學的難處，也讓大家共享進步的喜悅，把仁心落實在每天的互助中。',
        explanation: '口號清楚且適合受眾（1分）；曾子長久任仁的思想（1分）；孟子同憂同樂的思想（1分）；整合表達、字數大致符合（1分）。',
        score: 4,
        source: '篇章2、3；新增創作任務',
        articleIndex: [1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id: "R2-54",
        category:"能力點題",
        type:'短答題',
        question: '以「如果士的精神來到我們班」為題，寫一段50至80字的微型故事。須包含一個困難、一項具體行動，以及與至少一篇材料相符的結局。',
        options: [],
        correctAnswer: '班內有同學因缺課而跟不上進度。起初互助小組人手不足，大家仍輪流整理筆記，並按同學需要調整時間。一個月後，他重拾信心，組員也從共同進步中感到快樂。',
        explanation: '情境與困難清楚（1分）；具體行動（1分）；結局體現長久任仁或共同憂樂（1分）；故事連貫、字數大致符合（1分）。',
        score: 4,
        source: '篇章1至3；新增創作任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義',
    }
]